import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import axios from "axios";

const DesignerRoutes = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(0);
    const myToken = localStorage.getItem("JWT");

    useEffect(() => {
        setIsLoggedIn(1)
        const checkToken = async () => {
            try {
                if (!myToken) {
                    throw new Error("Token not found");
                }

                const response = await axios.post(`${process.env.REACT_APP_API_URL}api/verifyDevToken`, {
                    myToken,
                });


                setIsLoggedIn(2); // Si le token est présent, l'utilisateur est considéré comme connecté
            } catch (error) {

                setIsLoggedIn(3);
            }
        };

        checkToken();
    }, [myToken]);

    if (isLoggedIn === 1) {
        return <div className="transitionPage"></div> 
    } else if (isLoggedIn === 2) {
        return <Outlet />;
    } else if (isLoggedIn === 3) {
        let errorMessage = "Vous n'êtes pas authoriser a accéder a cette page"
        localStorage.setItem("errorMessage", errorMessage);
        return <Navigate to="/error" />;
    }

    
};

export default DesignerRoutes;
